import cleanupExpiredBookingSession from './cleanupExpiredBookingSession';
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { getCenterHealthInfo } from "../../api/routes";
import { updateTab } from "../../features/tab/tabSlice";
import setToSession from "./setToSession";

export default function PatientHealthInfo() {
  const dispatch = useDispatch();
  const [healthInfo, setHealthInfo] = useState([]);
  const [clickedHealthInfo, setClickedHealthInfo] = useState({});

  useEffect(() => {
    getCenterHealthInfo((isOk, data) => {
      if (!isOk) return alert(data.message);
      else {
        if (data.length === 0) {
          dispatch(updateTab(4))
        }
        else return setHealthInfo(data);
      }
    })
  }, [])

  const onLinkChange = (event, infoId) => {
    setClickedHealthInfo({
      ...clickedHealthInfo,
      [infoId]: { text: event.target.name, isChecked: event.target.checked },
    });
  }

  const object2arr = Object.keys(clickedHealthInfo).map((key) => ({ id: Number(key), text: clickedHealthInfo[key].text, isChecked: clickedHealthInfo[key].isChecked }));
  const selectedItem = object2arr.filter(item => item.isChecked !== false);

  const nextLevel = () => {
    setToSession("healthInformation", selectedItem, 30);
    return dispatch(updateTab(4))
  }
    useEffect(() => { if (!cleanupExpiredBookingSession()) dispatch(updateTab(0)); }, [dispatch])

  return (
    <>
      <div className="booking-health-grid">
        {healthInfo.length > 0 ? healthInfo.map((item) =>
          <label key={item.healthInfoId} className="booking-health-option">
            <input id={`health-${item.healthInfoId}`} type="checkbox" name={item.text} onChange={(event) => onLinkChange(event, item.healthInfoId)} className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300" />
            <span>{item.text}</span>
          </label>
        ) : 'هنوز متنی وارد نشده است!'}
      </div>
      <section className="booking-actions">
        <button type="button" onClick={nextLevel} className='focus:outline-none text-white  bg-[#4b9afe] hover:bg-blue-600 focus:ring-blue-300 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 w-[120px]'>ادامه</button>
      </section>
    </>
  )
}
